import React from 'react'
import { NavLink } from '@/components/admin/atoms/navigation/NavLink'
import { IconSlot } from '@/components/admin/atoms/layout/IconSlot'

interface NavItemProps {
  href: string
  icon: React.ReactNode
  label: string
  active?: boolean
  className?: never
}

export const NavItem: React.FC<NavItemProps> = ({ href, icon, label, active }) => (
  <NavLink href={href} active={active}>
    <IconSlot>{icon}</IconSlot>
    {label}
  </NavLink>
)
